import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ViewerManagerStructureAPISymbol, ComponentStructureFixerSymbol } from '@wix/thunderbolt-symbols'
import { ViewerManagerStructureApi, StructureAPIImplementor } from './viewerManagerStructureApi'
import { ViewerManagerApiImplementor } from 'thunderbolt-viewer-manager-types'
import { ComponentStructureFixer } from './componentStructureFixer'

export const editor: ContainerModuleLoader = (bind) => {
	bind(ViewerManagerStructureAPISymbol).to(ViewerManagerStructureApi)
	bind(ViewerManagerApiImplementor).to(StructureAPIImplementor)
	bind(ComponentStructureFixerSymbol).to(ComponentStructureFixer)
}

export { ViewerManagerStructureAPISymbol, ComponentStructureFixerSymbol }
